import { useEffect } from "react";

const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/2dbac991-9431-4c1c-baca-4d7548e28de1/images/fa45eb9dd9ed9f88ae0d4cb21f079b1b8017ccdf1241912933a5d95d597ba536.jpeg";
const SITE = "Espresso by Mahakali Studios";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Lightweight, dependency-free SEO/OG head manager for the marketing pages.
export function Seo({ title, description, image = OG_IMAGE, path = "" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE}` : SITE;
    document.title = fullTitle;
    const url = `${window.location.origin}${path || window.location.pathname}`;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", image);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setCanonical(url);
  }, [title, description, image, path]);
  return null;
}
